import type { ReactElement } from "react";

interface LoadingChoroplethProps {
  baseContainerClasses: string;
  className?: string;
}

export const LoadingChoropleth = ({
  baseContainerClasses,
  className,
}: LoadingChoroplethProps): ReactElement => (
  <div className={`${baseContainerClasses} ${className || ""}`}>
    <div className="bg-secondary mb-4 h-6 w-32 animate-pulse rounded" />
    <div className="flex h-80 w-full items-center justify-center">
      <div className="bg-secondary h-64 w-full animate-pulse rounded" />
    </div>
  </div>
);

LoadingChoropleth.displayName = "LoadingChoropleth";
